export default __webpack_public_path__ + "static/hmwrk logo-ac9ed9af951cc4ac92389a14bf02e4a2.png";